namespace TabAurous.Common {
    export interface FiltersForm {
        PartyId: Serenity.LookupEditor;
        VoucherTypeId: _Ext.EmptyLookupEditor;
        VoucherNo: _Ext.EmptyLookupEditor;
        BagNo: _Ext.EmptyLookupEditor;
    }

    export class FiltersForm extends Serenity.PrefixedContext {
        static formKey = 'Common.Filters';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FiltersForm.init)  {
                FiltersForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = _Ext.EmptyLookupEditor;

                Q.initFormType(FiltersForm, [
                    'PartyId', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w1,
                    'BagNo', w1
                ]);
            }
        }
    }
}
